import React, { HTMLAttributes, ReactNode } from 'react';

import { tv } from 'tailwind-variants';

import cn from '@/helpers/utils/classNames';

interface ParagraphProps extends HTMLAttributes<HTMLParagraphElement> {
  children: ReactNode;
  className?: string;
  variant?:
    | 'primary'
    | 'secondary'
    | 'light'
    | 'dark'
    | 'dark-red'
    | 'light-gray'
    | 'medium-gray'
    | 'dark-gray'
    | 'silver'
    | 'orange'
    | 'gray'
    | 'link';
}

export const paragraphStyles = tv({
  variants: {
    color: {
      primary: 'v2-text-primary',
      secondary: 'v2-text-secondary-light',
      light: 'v2-text-white',
      dark: 'v2-text-black',
      orange: 'v2-text-orange-400',
      'dark-red': 'v2-text-dark-red',
      'light-gray': 'v2-text-grayscale-95',
      'medium-gray': 'v2-text-grayscale-80',
      'dark-gray': 'v2-text-grayscale-96',
      silver: 'v2-text-silver',
      gray: 'v2-text-gray-900',
      link: 'v2-text-link',
    },
  },
});

// xs:text-sm xs:leading-5 leading-6 sm:text-base md:text-base
const Paragraph = ({ children, className, variant = 'light-gray', ...rest }: ParagraphProps) => {
  return (
    <p
      className={cn(
        paragraphStyles({
          color: variant,
        }),
        'v2-font-sweet-sans-pro v2-text-base v2-font-normal v2-leading-[26px]',
        className
      )}
      {...rest}
    >
      {children}
    </p>
  );
};

export default Paragraph;
